import React from 'react';
import {socialLinks} from '../data';
import '../styles/theme.css';

export default function SocialLinks() {

  return (
    <div className="socials">
      {socialLinks.map(({ id, icon: Icon, label, url }) => (
        <a key={id} href={url} target="_blank" rel="noopener noreferrer" title={label}>
          <Icon size={20} />
        </a>
      ))}
    </div>
  );
}
